module.exports = __webpack_public_path__ + "static/media/17.569381d9.jpg";